type ToastType = 'notice' | 'alert'

type ToastOptions = {
  type?: ToastType
}

export default class Toast {
  private message: string
  private type: ToastType
  private element: HTMLElement

  /** Creates a toast message ready to be inserted in the DOM. */
  constructor(message: string, options: ToastOptions = {}) {
    this.message = message
    this.type = options.type || 'notice'

    this.element = this.buildNode()
  }

  /** Displays the toast and lets its CSS animation lifecycle close it. */
  show() {
    document.body.appendChild(this.element)
  }

  /** Removes the toast from the DOM. */
  close() {
    this.element.remove()
  }

  private buildNode() {
    const node = document.createElement('div')
    node.classList.add('toast-wrapper')
    node.innerHTML = this.#template(this.type)
    node.addEventListener('animationend', () => this.close())
    node.querySelector('button')?.addEventListener('click', () => this.close())
    return node
  }

  #template(type: ToastType) {
    return `
    <div class="message-card is-toast ${type}">
      <div class="text-label-small">${this.message}</div>
      <button type="button" class="close-button"><font-icon class="cross"></font-icon></button>
    </div>
    `
  }
}
